import React from 'react'
import useGetBalanceHook from '../../hooks/useGetBalance'
import View from './view'

const UserBalance = () => {
    let balance = useGetBalanceHook()
    return <View balance={balance} />
}

export default UserBalance